export default __webpack_public_path__ + "static/media/galeria-drivr1.257584f0.JPG";